import { updatePage } from '!/actions/creators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import PaginationItem from './PaginationItem/PaginationItem';
import { getLocale } from '!/common/helpers';

const actions = { changePage: updatePage };
class Pagination extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pageCount: Math.ceil(this.props.total / this.props.perPage)
    };

    this.pagerItems = [];
  }

  componentDidUpdate(prevProps) {
    if (prevProps.total !== this.props.total) {
      this.setState({ pageCount: Math.ceil(this.props.total / this.props.perPage) });
    }
  }

  static propTypes = {
    total: PropTypes.number.isRequired,
    perPage: PropTypes.number,
    itemPadding: PropTypes.number.isRequired, // how many items max to show before/after the current item
    itemsToShow: PropTypes.number.isRequired,
    onChange: PropTypes.func,
    page: PropTypes.number
  };

  static defaultProps = {
    perPage: 48,
    itemPadding: 3,
    itemsToShow: 5
  };

  createItems({ itemPadding, itemsToShow, currentPage }) {
    const start = currentPage - itemPadding > 0 ? currentPage - itemPadding : 1;
    const end =
      currentPage + itemPadding < itemsToShow && itemsToShow < this.state.pageCount
        ? itemsToShow
        : currentPage + itemPadding < this.state.pageCount
          ? currentPage + itemPadding
          : this.state.pageCount;

    // clear pager items
    this.pagerItems = [];

    for (let i = start; i <= end; i++) {
      this.pagerItems.push(i);
    }

    return this.pagerItems;
  }

  pagerItem({ label, ariaLabel, pageNumber, isHidden = false, isActive = false }) {
    const query = this.props.queryString ? `q=${this.props.queryString}` : '';
    const page = pageNumber > 1 ? `&p=${pageNumber}` : '';
    const url = `/search?${query}${page}`;

    return (
      !isHidden && (
        <PaginationItem
          ariaLabel={ariaLabel}
          handleClick={this.props.changePage}
          label={label}
          key={ariaLabel + pageNumber}
          isActive={isActive}
          pageNumber={pageNumber}
          url={url}
          query={this.props.queryString}
        />
      )
    );
  }

  firstPage({ total, currentPage }) {
    return this.pagerItem({
      ariaLabel: getLocale('First Page'),
      isHidden: total === 0 || currentPage === 1,
      label: '«',
      pageNumber: 0
    });
  }

  lastPage({ total, currentPage }) {
    return this.pagerItem({
      ariaLabel: getLocale('Last Page'),
      isHidden: total === 0 || currentPage === this.state.pageCount,
      label: '»',
      pageNumber: this.state.pageCount
    });
  }

  previousPage({ total, currentPage }) {
    return this.pagerItem({
      ariaLabel: getLocale('Previous Page'),
      isHidden: total === 0 || currentPage === 1,
      label: '<',
      pageNumber: currentPage - 1
    });
  }

  nextPage({ total, currentPage }) {
    return this.pagerItem({
      ariaLabel: getLocale('Next Page'),
      isHidden: total === 0 || currentPage === this.state.pageCount,
      label: '>',
      pageNumber: currentPage + 1
    });
  }

  pages({ currentPage }) {
    return this.createItems(this.props).map(pageNumber =>
      this.pagerItem({
        ariaLabel: getLocale('Page %s', pageNumber),
        isActive: pageNumber === currentPage,
        label: pageNumber,
        pageNumber
      })
    );
  }

  render() {
    return (
      <nav className="pagination">
        <ul>
          {this.firstPage(this.props)}
          {this.previousPage(this.props)}
          {this.pages(this.props)}
          {this.nextPage(this.props)}
          {this.lastPage(this.props)}
        </ul>
        {this.state.pageCount > 1 && (
          <small className="mt">{`${this.props.currentPage}/${this.state.pageCount}`}</small>
        )}
      </nav>
    );
  }
}

function mapStateToProps({ q, total, page, perPage }) {
  return {
    queryString: q,
    total,
    currentPage: page,
    perPage
  };
}

export default connect(
  mapStateToProps,
  actions
)(Pagination);
